import React from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Form2 = () => {
    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className="container mt-5">
                <form>
                    <h4 className='mt-2 mb-2 text-center'>FORM - 2</h4>
                    <p className='mb-0'>A. About the Organisation: (Write up in brief)</p>
                    {/* Section i */}
                    <div className="mb-3">
                        <label htmlFor="organizationSnapshot" className="form-label">i. A snapshot of the Organisation, chief promoter, the key activities, challenges faced, competition, exports etc.</label>
                        <textarea className="form-control" id="organizationSnapshot" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* Section ii */}
                    <div className="mb-3">
                        <label htmlFor="visionMission" className="form-label">ii. Vision, mission and policy of organization</label>
                        <textarea className="form-control" id="visionMission" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* Section iii */}
                    <div className="mb-3">
                        <label htmlFor="achievements" className="form-label">iii. Important achievements of Organisation in the past few years</label>
                        <textarea className="form-control" id="achievements" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* Section iv */}
                    <div className="mb-3">
                        <label htmlFor="contribution" className="form-label">iv. Contribution to exchequer, society, CSR etc.</label>
                        <textarea className="form-control" id="contribution" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* Size of Organisation */}
                    <h5>1. Size of Organisation: (investment in plant & machinery) in Rs Cr</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>A. Below 10</td>
                                <td><input type="radio" name="size" /></td>
                            </tr>
                            <tr>
                                <td>B. 10 - 20</td>
                                <td><input type="radio" name="size" /></td>
                            </tr>
                            <tr>
                                <td>C. 20 - 50</td>
                                <td><input type="radio" name="size" /></td>
                            </tr>
                            <tr>
                                <td>D. Above 50</td>
                                <td><input type="radio" name="size" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Ownership */}
                    <h5>2. Ownership (tick as applicable)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>A. Sole Proprietor</td>
                                <td><input type="checkbox" name="ownership" /></td>
                            </tr>
                            <tr>
                                <td>B. Partnership Firm</td>
                                <td><input type="checkbox" name="ownership" /></td>
                            </tr>
                            <tr>
                                <td>C. Private limited Company</td>
                                <td><input type="checkbox" name="ownership" /></td>
                            </tr>
                            <tr>
                                <td>D. Limited Company</td>
                                <td><input type="checkbox" name="ownership" /></td>
                            </tr>
                            <tr>
                                <td>E. Cooperative Society</td>
                                <td><input type="checkbox" name="ownership" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Sector */}
                    <h5>3. Sector (tick as applicable)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>A. Private</td>
                                <td><input type="checkbox" name="sector" /></td>
                            </tr>
                            <tr>
                                <td>B. Public</td>
                                <td><input type="checkbox" name="sector" /></td>
                            </tr>
                            <tr>
                                <td>C. Government - Central</td>
                                <td><input type="checkbox" name="sector" /></td>
                            </tr>
                            <tr>
                                <td>D. Government - State</td>
                                <td><input type="checkbox" name="sector" /></td>
                            </tr>
                            <tr>
                                <td>E. Others</td>
                                <td><input type="checkbox" name="sector" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* No of Employees */}
                    <h5>4. No of Employees (tick as applicable and mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>A. Less than 20</td>
                                <td><input type="checkbox" name="employees" /></td>
                            </tr>
                            <tr>
                                <td>B. 20 - 50</td>
                                <td><input type="checkbox" name="employees" /></td>
                            </tr>
                            <tr>
                                <td>C. 50 - 100</td>
                                <td><input type="checkbox" name="employees" /></td>
                            </tr>
                            <tr>
                                <td>D. Above 100</td>
                                <td><input type="checkbox" name="employees" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Financial results for last 3 years */}
                    <h5>5. Financial results for last 3 years (As per Annual reports) (In Rs Cr)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>S No</th>
                                <th>Year</th>
                                <th>Turnover</th>
                                <th>Net Profit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>2021-22</td>
                                <td>0-10</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>2022-23</td>
                                <td>10-50</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>2023-24</td>
                                <td>50-100 & above</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Main Products/Services */}
                    <h5>6. Main Products/Services (Mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>S No</th>
                                <th>Description</th>
                                <th>Capacity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Major facilities */}
                    <h5>7. Major facilities (mention details) (Fill relevant details based on type of your company)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>S No</th>
                                <th>Facility</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>a</td>
                                <td>Land area</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>b</td>
                                <td>Factory built up area</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>c</td>
                                <td>Major Equipment</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>d</td>
                                <td>Specialized Facility</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>e</td>
                                <td>Services</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>8. Technology adopted (tick as applicable and mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>a. Traditional</td>
                                <td><input type="checkbox" name="technology" /></td>
                            </tr>
                            <tr>
                                <td>b. Indigenous</td>
                                <td><input type="checkbox" name="technology" /></td>
                            </tr>
                            <tr>
                                <td>c. In house R & D</td>
                                <td><input type="checkbox" name="technology" /></td>
                            </tr>
                            <tr>
                                <td>d. Foreign Technology</td>
                                <td><input type="checkbox" name="technology" /></td>
                            </tr>
                            <tr>
                                <td>e. Franchise</td>
                                <td><input type="checkbox" name="technology" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <textarea className="form-control mt-2 mb-2" rows="3" placeholder="Details in brief" style={{ border: '2px solid #000' }}></textarea>


                    {/* Quality Compliance */}
                    <h5>9. Quality Compliance (tick as applicable and mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>a. ISO</td>
                                <td><input type="checkbox" name="quality" /></td>
                            </tr>
                            <tr>
                                <td>b. BIS</td>
                                <td><input type="checkbox" name="quality" /></td>
                            </tr>
                            <tr>
                                <td>c. GMP/WHO/FDA/HACCP</td>
                                <td><input type="checkbox" name="quality" /></td>
                            </tr>
                            <tr>
                                <td>d. Any other, to mention</td>
                                <td><input type="checkbox" name="quality" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <textarea className="form-control mt-2 mb-2" rows="3" placeholder="Details in brief" style={{ border: '2px solid #000' }}></textarea>

                    {/* Management Functions */}
                    <h5>10. Management Functions – Has (tick as applicable and mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>a. Human Resources Department</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>b. Finance & Accounts</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>c. Marketing/ Business Development</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>d. R & D</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>e. Internal Audit</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>f. Quality Assurance</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                            <tr>
                                <td>g. Any other, please specify</td>
                                <td><input type="checkbox" name="management" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <textarea className="form-control mt-2 mb-2" rows="3" placeholder="Details in brief" style={{ border: '2px solid #000' }}></textarea>

                    {/* Level of IT Intervention */}
                    <h5>12. Level of IT intervention (tick as applicable and mention details)</h5>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>Option</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>a. Use of ERP</td>
                                <td><input type="checkbox" name="ITintervention" /></td>
                            </tr>
                            <tr>
                                <td>b. Customized software</td>
                                <td><input type="checkbox" name="ITintervention" /></td>
                            </tr>
                            <tr>
                                <td>c. General office solutions</td>
                                <td><input type="checkbox" name="ITintervention" /></td>
                            </tr>
                            <tr>
                                <td>d. No IT facility</td>
                                <td><input type="checkbox" name="ITintervention" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <textarea className="form-control mt-2 mb-2" rows="3" placeholder="Details in brief" style={{ border: '2px solid #000' }}></textarea>

                    {/* In receipt of any Award */}
                    <h5>13. In receipt of any Award/recognition of repute</h5>
                    <div className="mb-3">
                        <label className="form-label">YES/NO</label>
                        <div>
                            <input type="radio" name="award" /> YES
                            <input type="radio" name="award" /> NO
                        </div>
                        <textarea className="form-control mt-2" rows="3" placeholder="If yes, to mention details" style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* Strategic Plan */}
                    <h5>14. Does the Organization have a Strategic Plan for future growth</h5>
                    <div className="mb-3">
                        <label className="form-label">YES/NO</label>
                        <div>
                            <input type="radio" name="strategicPlan" /> YES
                            <input type="radio" name="strategicPlan" /> NO
                        </div>
                        <textarea className="form-control mt-2" rows="3" placeholder="If yes, mention details" style={{ border: '2px solid #000' }}></textarea>
                    </div>

                    {/* About Product/Service */}
                    <h3>A. About Product/ Service:</h3>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>S No</th>
                                <th>Description</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Description of product / service</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Capacity</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Features of product</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Uniqueness, if any</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Market</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Export content in Turnover</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                        </tbody>
                    </table>

                    {/* About Chief Promotor */}
                    <h3>B. About Chief Promotor:</h3>
                    <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                        <thead>
                            <tr>
                                <th>S No</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Educational qualification</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Experience in line</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Are you first generation entrepreneur?</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Contribution to the Organization</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Any relevant details, to specify</td>
                                <td><input type="text" className="form-control" placeholder="" /></td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="mb-3">
                        <label className="form-label">Signature:</label>
                        <input type="file" className="form-control" placeholder="Signature" style={{ border: '2px solid #000' }} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Name:</label>
                        <input type="text" className="form-control" placeholder="Name" style={{ border: '2px solid #000' }} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Designation:</label>
                        <input type="text" className="form-control" placeholder="Designation" style={{ border: '2px solid #000' }} />
                    </div>

                    <p><strong>(To be signed by CEO/MD of Organization)</strong></p>

                </form>
            </div>
            
            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default Form2;
